import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import '../css/LayoutShell.css';
import * as FiIcons from 'react-icons/fi';
import NotificationBell from './NotificationBell';
import { isNotificationsEnabled } from '../utils/notifications';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const [isMobile, setIsMobile] = React.useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = React.useState(false);

  React.useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener?.('change', update);
    return () => mq.removeEventListener?.('change', update);
  }, []);

  React.useEffect(() => {
    if (!isMobile) setMobileSidebarOpen(false);
  }, [isMobile]);

  const FiMenu = FiIcons.FiMenu as unknown as React.FC;
  const FiMessageSquare = FiIcons.FiMessageSquare as unknown as React.FC;
  const showSalesCopilotCta = location.pathname !== '/sales-copilot';
  const notificationsEnabled = isNotificationsEnabled();

  return (
    <div className="app-shell">
      {isMobile && (
        <div className="app-topbar">
          <button className="app-menu-btn" onClick={() => setMobileSidebarOpen(true)} aria-label="Open menu">
            <FiMenu />
          </button>
          <div className="app-topbar-title">OTA Prime Admin</div>
          <div style={{ width: 40 }} />
        </div>
      )}

      {isMobile && mobileSidebarOpen && (
        <div className="app-overlay" onClick={() => setMobileSidebarOpen(false)} />
      )}

      <Sidebar
        isMobile={isMobile}
        mobileOpen={mobileSidebarOpen}
        onRequestClose={() => setMobileSidebarOpen(false)}
      />

      <main className="app-main">{notificationsEnabled && <div className="app-notification-anchor"><NotificationBell /></div>}{children}</main>

      {showSalesCopilotCta && (
        <Link
          to="/sales-copilot"
          className="sales-copilot-cta"
          aria-label="Open Sales Copilot"
          title="Open Sales Copilot"
        >
          <FiMessageSquare />
        </Link>
      )}
    </div>
  );
};

export default Layout;
